"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getByassTokenFromUrl() {
  return new URLSearchParams(window.location.search).get('bypassToken');
}
function setCookie(name, value) {
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(value));
}
function saveTokenIntoCookieIfPresent() {
  var token = getByassTokenFromUrl();
  if (token) {
    setCookie('cic_token', token);
  }
}
var _default = exports.default = saveTokenIntoCookieIfPresent;